import { EventService } from '@novakid/frontend-core';

export class ScreenLoaderService {
  public static readonly CONTAINER_APP_BOUNCER_START = 'CONTAINER_APP_SCREEN_LOADER_START';

  public static readonly CONTAINER_APP_BOUNCER_STOP = 'CONTAINER_APP_SCREEN_LOADER_STOP';

  public static start() {
    EventService.dispatch(this.CONTAINER_APP_BOUNCER_START);
  }

  public static stop() {
    EventService.dispatch(this.CONTAINER_APP_BOUNCER_STOP);
  }
}